import { authedFetch } from './backendFetch.js';
import { creditWalletOperationCompleted } from '../creditWallet/WalletBalanceContext.js';

// Azure cannot bind its token to our database session. Keep it only in memory and
// prove the session remains OPEN by heartbeating the server every minute.
export async function openLiveSession(diagnostics) {
  const response = await authedFetch(`${process.env.REACT_APP_MAIN_BACKEND_URL}/scribe/live-sessions`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({}),
  }, diagnostics);
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Unable to start live transcription');
  creditWalletOperationCompleted();
  return { sessionId: data.session_id, authToken: data.speech_token, region: data.region };
}

// The heartbeat response also carries a fresh Azure speech token when the
// session is still OPEN — the caller must apply it to the recognizer, because
// Azure authorization tokens expire after 10 minutes and the SDK's periodic
// websocket reconnect fails (stopping transcription) on an expired token.
export async function heartbeatLiveSession(sessionId) {
  const response = await authedFetch(`${process.env.REACT_APP_MAIN_BACKEND_URL}/scribe/live-sessions/${sessionId}/heartbeat`, { method: 'POST' });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || 'Live session heartbeat rejected');
  return data;
}

// `keepalive: true` lets the settle POST complete even as the page is being
// torn down (route change or tab close), so a live session is never left OPEN
// just because the user navigated away mid-recording.
// `signal` lets a caller time out a hanging settle without blocking its retries.
export async function settleLiveSession(sessionId, options = {}) {
  const response = await authedFetch(`${process.env.REACT_APP_MAIN_BACKEND_URL}/scribe/live-sessions/${sessionId}/settle`, {
    method: 'POST', keepalive: options.keepalive === true, ...(options.signal ? { signal: options.signal } : {}),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || 'Live session settlement failed');
  creditWalletOperationCompleted();
  return data;
}

// Chat's legacy voice-input screens still import this name.  Their old
// implementation fetched /speech/token and cached a cross-session Azure token
// in a browser cookie, which bypasses the wallet-backed live-session boundary.
// Do not silently revive that path: those screens need their own metered
// capability contract before voice input can be enabled again.
export async function getTokenOrRefresh() {
  throw new Error('Voice input is temporarily unavailable while its metered session is migrated.');
}
